import { Component } from '@angular/core';
import { Unsubscriber } from '@shared';
import { MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { AppRoutes } from '@app';

@Component({
  selector: 'app-forbidden-payment',
  templateUrl: './forbidden-payment.component.html',
  styleUrls: ['./forbidden-payment.component.scss'],
})
export class ForbiddenPaymentComponent extends Unsubscriber {
  constructor(
    private dialog: MatDialogRef<ForbiddenPaymentComponent>,
    private router: Router,
  ) {
    super();
  }

  cancel(): void {
    this.dialog.close(false);
    this.router.navigate([AppRoutes.invoices_my]);
  }
}
